import { toast } from "react-toastify";
import { loadingModel } from "./CommonActions";
import {
  createUserApi,
  deleteUserApi,
  getUsersApi,
  sendPasswordEmailApi,
  updatePasswordAndSendApi,
  updateUserApi,
} from "../../services/UserService";
import { GET_USERS } from "./UsersTypes";

export function deleteUserAction(id, navigate) {
  return (dispatch, getState) => {
    deleteUserApi(id)
      .then((response) => {
        //   dispatch(confirmedDeletePostAction(postId));
        // navigate.push("/users");
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong!";
        toast.error(message);
        return error;
      });
  };
}

// export function confirmedDeletePostAction(postId) {
//   return {
//     type: CONFIRMED_DELETE_POST_ACTION,
//     payload: postId,
//   };
// }

export function createUser(data, navigate) {
  return async (dispatch, getState) => {
    const response = await createUserApi(data);
    return response;
  };
}

export function getUsers({ page = 1, search = "", roles = "", limit = 10 }) {
  return (dispatch, getState) => {
    dispatch(loadingModel(true, GET_USERS));
    getUsersApi({ page, search, limit, roles }).then((response) => {
      // let posts = formatPosts(response.data);
      dispatch(loadingModel(false, GET_USERS));
      const resData = response?.data?.data;
      // dispatch(confirmedGetUsersAction(response?.data?.data));
      dispatch({
        type: GET_USERS,
        payload: {
          data: resData?.data ?? [], // ✅ users array only
          page: resData?.page ?? 1,
          total: resData?.total ?? 0,
          totalPages: resData?.totalPages ?? 0,
          stats: resData?.stats ?? {}, // ✅ stats object
        },
      });
    });
  };
}

export function confirmedGetUsersAction(data) {
  return {
    type: GET_USERS,
    payload: data,
  };
}

// export function loadingModel(loading) {
//   return {
//     type: "LOADING",
//     loading,
//   };
// }

export function updateUserAction(data, navigate) {
  return async (dispatch, getState) => {
    const response = await updateUserApi(data, data._id);
    return response;
  };
}

// ✅ Only send email with password
export function sendPasswordEmailAction(id) {
  return async (dispatch, getState) => {
    try {
      const response = await sendPasswordEmailApi(id);
      // toast.success("Password sent successfully to user email!");
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to send password!";
      toast.error(message);
      return error;
    }
  };
}

// ✅ Update password & send email
export function updatePasswordAndSendAction(id, newPassword) {
  return async (dispatch, getState) => {
    try {
      const response = await updatePasswordAndSendApi(id, newPassword);
      // toast.success("Password updated & sent successfully!");
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to update & send password!";
      toast.error(message);
      return error;
    }
  };
}
